import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/process-flow-step"

class processFlowStepService {

    selectList(processFlowId = 0, grouped = false) {

        let params = new URLSearchParams()

        if (processFlowId > 0)
            params.append("processFlowId", processFlowId)

        if(grouped)
            params.append("grouped", "true")

        return http.list(path + "/selectList", params);

    }

}

export default new processFlowStepService();


